import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { Helpers } from '@shared/utils/Helpers';
import { CORE_LANGUAGES, ADDITIONAL_LANGUAGES } from '@entities/language/model/constants';
import { changeLanguage } from '@entities/language/store';
import { setHtmlDirection } from '@shared/utils';
import { LogService } from '@shared/services/LogService';

export const useLanguage = (shouldIgnore = false) => {
  const routeParams = useParams<{ lang?: string }>();
  const { i18n } = useTranslation();
  useEffect(() => {
    if (shouldIgnore) {
      return;
    }
    const logService = new LogService();
    logService.init();
    const locale = routeParams.lang || Helpers.getUrlParameter('lang');

    if (locale) {
      const supportedLanguage = [...CORE_LANGUAGES, ...ADDITIONAL_LANGUAGES].find(
        (el) => el.lang === locale
      );

      if (supportedLanguage) {
        const language = {
          locale,
          displayName: supportedLanguage.name,
          direction: supportedLanguage.direction,
        };
        i18n.changeLanguage(locale);
        changeLanguage(language);
        setHtmlDirection(supportedLanguage.direction);
      }
    }
  }, [shouldIgnore, routeParams.lang, i18n]);
};
